module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "label": "Select datetime"
    }
  }, [_c('b-datetimepicker', {
    attrs: {
      "placeholder": "Click to select..."
    },
    model: {
      value: (_vm.datetime),
      callback: function($$v) {
        _vm.datetime = $$v
      },
      expression: "datetime"
    }
  }, [_c('template', {
    slot: "left"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        _vm.datetime = new Date()
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "clock"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Now")])], 1)]), _vm._v(" "), _c('template', {
    slot: "right"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        _vm.datetime = null
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Clear")])], 1)])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d3afde0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/datetimepicker/examples/ExFooter.vue
// module id = 1054
// module chunks = 18 141